import { Breakpoints, styled } from '@vw-marketing/us-components';

export const StyledVehicleCardWrapper = styled.div`
  ${() => `
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #DFE4E8;
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
    .top  {
      padding: 6px;
      flex-shrink: 0;
    }

    @media (max-width: ${Breakpoints.b560}px) {
      margin-top: 15px;
    }
 `}
`;

export const StyledOfferTypeLabelWrapper: any = styled.div`
  width: 100%;
  position: relative;
`;

export const StyledBlackContainer: any = styled.div`
  background-color: #ffffff;
  position: absolute;
  top: 60%;
  left: 2.6%;
  transform: translate(2.6%, -60%);
  width: max-content;
  z-index: 1;
`;

export const StyledOfferTypeLabel: any = styled.div`
  background-color: #FFD100;
  color: black;
  display: inline-block;
  padding: 5px 10px;
`;

export const StyledVehicleImageWrapper = styled.div<any>`
  ${({ imageUrl, placeHolderUrl }) => `
    text-align: center;
    position: relative;
    height: 0;
    padding-top: 72.289%;
    overflow: hidden;
    cursor: pointer;
    .image-content {
        background-image: url(${imageUrl}), url(${placeHolderUrl});
        background-size: contain;
        background-repeat: no-repeat;
        background-position: 50%;
        position: absolute;
        top: 12px;
        left: 0;
        width: 100%;
        height: 100%;
    }
  `}
`;

export const StyledVehicleContentWrapper = styled.div`
  ${() => `
    display: flex;
    width: 100%;
    height: 100%;
    flex-wrap: wrap;
    padding-bottom: 14px;
    border-bottom: 1px solid rgb(0,0,0,0.2);

    .data-wrapper {
      display: flex;
      width: 100%;
      height: fit-content;
      flex-wrap: wrap;
    }
    .model-name {
        width: 50%;
        text-transform: uppercase;
    }
    .model-price {
        width: 50%;
        display: flex;
        align-items: baseline;
        justify-content: end;

    }
    .model-information-container {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
    .model-mileage {
        width: 50%;
        align-self: baseline;
        text-align: end;
        color: #001E50;
    }

    .model-trim {
        width: 50%;
        align-self: baseline;
    }
    .model-warranty {
        margin-top: 22px;
        color: #001E50;
        display: flex;
        column-gap: 2px;
        text-align: end;
        p {
          text-decoration-line: underline;

        }
        .sub-text-constainer {
          padding-top: 10px;
          margin-left: 2px;
          text-decoration-line:  none !important;
          .span-text {
            text-decoration-line:  none;
          }
        }
    }
`}
`;
export const StyledVehicleDealerWrapper = styled.div`
  ${() => `
    padding-top: 10px;

    sub {
      padding-left: 5px;
      bottom: 0;
    }

    .dealer-phone {
      padding-top: 4px;
        a {
          cursor: pointer;
          color: #001E50;
            ::hover {
              color: #37C1EF;
            }
        }
    }

    .view-details-cta {
      display: flex;
      gap: 20px;
      justy-content: space-between;
      margin-top: 24px;
      width: 100%;

      button {
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
      }
    }
`}
`;

export const StyledVehicleContentContainer = styled.div`
  ${() => `
    padding: 14px 15px;
    // border-top: 1px solid rgb(0,0,0,0.2);
    display: flex;
    flex-direction: column;
    height: 100%;
`}
`;
